import { getLocalClientCompanyWarehouse } from '../func'
import { ClientCompanyWarehouseData, NotificationItem } from '../types'

const MAXIMUM_NOTI_COUNT = 99

export const getCountValue = (count: number) => {
  return count > MAXIMUM_NOTI_COUNT ? `${MAXIMUM_NOTI_COUNT}⁺` : count
}

export const extractCodeAndNom = (code_nom: string): [string, string] => {
  const index = code_nom.indexOf('_')
  if (index < 0) {
    return [code_nom, code_nom]
  }
  const code = code_nom.substring(0, index)
  const nom = code_nom.substring(index + 1)
  return [code, nom]
}

export const getCurrentNotiCount = (
  notifications: NotificationItem[],
  choosingClient: string,
  choosingCompany: string,
  choosingWarehouse: string
) => {
  const currentNoti = notifications.find(
    ({ client_id, company_id, warehouse_id }) =>
      client_id === choosingClient &&
      company_id === choosingCompany &&
      warehouse_id === choosingWarehouse
  )
  return currentNoti ? currentNoti.quantity : 0
}

export const genToolTip = (
  notificationList: NotificationItem[],
  allStandards: Map<string, ClientCompanyWarehouseData>
) => {
  const tooltips: NotificationItem[] = []
  const rest: NotificationItem[] = []
  notificationList.forEach((item, index) => {
    const { client_id, company_id, warehouse_id, quantity } = item
    if (client_id && company_id && warehouse_id && quantity > 0) {
      const key = `${client_id}-${company_id}-${warehouse_id}`
      const standard = allStandards.get(key)
      if (standard) {
        tooltips.push({
          ...item,
          client_code: standard.client_code,
          client_nom: standard.client_nom,
          company_code: standard.company_code,
          company_nom: standard.company_nom,
          warehouse_code: standard.warehouse_code,
          warehouse_nom: standard.warehouse_nom,
        })
        allStandards.delete(key)
      }
    }
  })
  allStandards.forEach((value) => {
    rest.push({
      ...value,
      quantity: 0,
    })
  })
  const result = [...tooltips, ...rest]
  const { localClientId, localCompanyId, localWarehouseId } =
    getLocalClientCompanyWarehouse()
  const index = result.findIndex(
    ({ client_id, company_id, warehouse_id }) =>
      client_id === localClientId &&
      company_id === localCompanyId &&
      warehouse_id === localWarehouseId
  )
  if (index !== -1) {
    const selectedEnv = result.splice(index, 1)[0]
    selectedEnv.isActive = true
    result.unshift(selectedEnv)
  }
  return result
}

export const getEnv = ({
  client_code,
  client_nom,
  company_code,
  company_nom,
  warehouse_code,
  warehouse_nom,
}: {
  client_code: string
  client_nom: string
  company_code: string
  company_nom: string
  warehouse_code: string
  warehouse_nom: string
}) => {
  return `${client_code}_${client_nom} | ${company_code}_${company_nom} | ${warehouse_code}_${warehouse_nom}`
}
